/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SQLModelPage_SealogEventGeographyResponse_ } from '../models/SQLModelPage_SealogEventGeographyResponse_';
import type { SQLModelPage_str_ } from '../models/SQLModelPage_str_';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SealogService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Unique Sealog Event Values
     * @returns SQLModelPage_str_ Successful Response
     * @throws ApiError
     */
    public listUniqueSealogEventValues({
        query,
        hasDataAsset,
        eventValue,
        eventFreeTexts,
        eventOptionNames,
        eventOptionValues,
        realAssetDeploymentPublicId,
        page = 1,
        size = 50,
    }: {
        query?: string,
        hasDataAsset?: boolean,
        eventValue?: Array<string>,
        eventFreeTexts?: Array<string>,
        eventOptionNames?: Array<string>,
        eventOptionValues?: Array<string>,
        realAssetDeploymentPublicId?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<SQLModelPage_str_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sealog/unique_event_value',
            query: {
                'query': query,
                'has_data_asset': hasDataAsset,
                'event_value': eventValue,
                'event_free_texts': eventFreeTexts,
                'event_option_names': eventOptionNames,
                'event_option_values': eventOptionValues,
                'real_asset_deployment_public_id': realAssetDeploymentPublicId,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unique Sealog Event Free Texts
     * @returns SQLModelPage_str_ Successful Response
     * @throws ApiError
     */
    public listUniqueSealogEventFreeTexts({
        query,
        hasDataAsset,
        eventValue,
        eventFreeTexts,
        eventOptionNames,
        eventOptionValues,
        realAssetDeploymentPublicId,
        page = 1,
        size = 50,
    }: {
        query?: string,
        hasDataAsset?: boolean,
        eventValue?: Array<string>,
        eventFreeTexts?: Array<string>,
        eventOptionNames?: Array<string>,
        eventOptionValues?: Array<string>,
        realAssetDeploymentPublicId?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<SQLModelPage_str_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sealog/unique_event_free_text',
            query: {
                'query': query,
                'has_data_asset': hasDataAsset,
                'event_value': eventValue,
                'event_free_texts': eventFreeTexts,
                'event_option_names': eventOptionNames,
                'event_option_values': eventOptionValues,
                'real_asset_deployment_public_id': realAssetDeploymentPublicId,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unique Sealog Event Option Names
     * @returns SQLModelPage_str_ Successful Response
     * @throws ApiError
     */
    public listUniqueSealogEventOptionNames({
        query,
        hasDataAsset,
        eventValue,
        eventFreeTexts,
        eventOptionNames,
        eventOptionValues,
        realAssetDeploymentPublicId,
        page = 1,
        size = 50,
    }: {
        query?: string,
        hasDataAsset?: boolean,
        eventValue?: Array<string>,
        eventFreeTexts?: Array<string>,
        eventOptionNames?: Array<string>,
        eventOptionValues?: Array<string>,
        realAssetDeploymentPublicId?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<SQLModelPage_str_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sealog/unique_event_option_name',
            query: {
                'query': query,
                'has_data_asset': hasDataAsset,
                'event_value': eventValue,
                'event_free_texts': eventFreeTexts,
                'event_option_names': eventOptionNames,
                'event_option_values': eventOptionValues,
                'real_asset_deployment_public_id': realAssetDeploymentPublicId,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unique Sealog Event Option Values
     * @returns SQLModelPage_str_ Successful Response
     * @throws ApiError
     */
    public listUniqueSealogEventOptionValues({
        query,
        hasDataAsset,
        eventValue,
        eventFreeTexts,
        eventOptionNames,
        eventOptionValues,
        realAssetDeploymentPublicId,
        page = 1,
        size = 50,
    }: {
        query?: string,
        hasDataAsset?: boolean,
        eventValue?: Array<string>,
        eventFreeTexts?: Array<string>,
        eventOptionNames?: Array<string>,
        eventOptionValues?: Array<string>,
        realAssetDeploymentPublicId?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<SQLModelPage_str_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sealog/unique_event_option_value',
            query: {
                'query': query,
                'has_data_asset': hasDataAsset,
                'event_value': eventValue,
                'event_free_texts': eventFreeTexts,
                'event_option_names': eventOptionNames,
                'event_option_values': eventOptionValues,
                'real_asset_deployment_public_id': realAssetDeploymentPublicId,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Sealog Event
     * @returns SQLModelPage_SealogEventGeographyResponse_ Successful Response
     * @throws ApiError
     */
    public searchSealogEvent({
        dataAssetPublicId,
        sealogEventQuery,
        sealogEventValues,
        sealogEventFreeTexts,
        sealogEventOptionNames,
        sealogEventOptionValues,
        realAssetDeploymentPublicId,
        regex,
        includeDataAssets = false,
        page = 1,
        size = 50,
    }: {
        dataAssetPublicId?: string,
        sealogEventQuery?: string,
        sealogEventValues?: Array<string>,
        sealogEventFreeTexts?: Array<string>,
        sealogEventOptionNames?: Array<string>,
        sealogEventOptionValues?: Array<string>,
        realAssetDeploymentPublicId?: string,
        regex?: boolean,
        includeDataAssets?: boolean,
        page?: number,
        size?: number,
    }): CancelablePromise<SQLModelPage_SealogEventGeographyResponse_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sealog/search',
            query: {
                'data_asset_public_id': dataAssetPublicId,
                'sealog_event_query': sealogEventQuery,
                'sealog_event_values': sealogEventValues,
                'sealog_event_free_texts': sealogEventFreeTexts,
                'sealog_event_option_names': sealogEventOptionNames,
                'sealog_event_option_values': sealogEventOptionValues,
                'real_asset_deployment_public_id': realAssetDeploymentPublicId,
                'regex': regex,
                'include_data_assets': includeDataAssets,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
